var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ikomsk"},[_vm._v(" "+_vm._s(String(_vm.addCommas(_vm.item.ikomsk)).replace(",00", ""))+" "),_c('br'),_c('span',{staticClass:"procent"},[_vm._v(_vm._s(_vm.procent(_vm.item.ikomsk, _vm.calc.summ, _vm.calc.days, _vm.yearProcent)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }